"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoListItem = void 0;
var react_1 = __importStar(require("react"));
var ListItemAvatar_1 = __importDefault(require("@mui/material/ListItemAvatar"));
var css_1 = require("@emotion/css");
var base_1 = require("@mui/base");
var utilities_1 = require("../utilities");
var prop_types_1 = __importDefault(require("prop-types"));
var InfoListItemStyledComponents_1 = require("./InfoListItemStyledComponents");
var InfoListItemClasses_1 = require("./InfoListItemClasses");
var MAX_SUBTITLE_ELEMENTS = 6;
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        avatar: ['avatar'],
        divider: ['divider'],
        icon: ['icon'],
        info: ['info'],
        listItemText: ['listItemText'],
        listItemButtonRoot: ['listItemButtonRoot'],
        rightComponent: ['rightComponent'],
        separator: ['separator'],
        statusStripe: ['statusStripe'],
        subtitle: ['subtitle'],
        title: ['title'],
        chevron: ['chevron'],
    };
    return (0, base_1.unstable_composeClasses)(slots, InfoListItemClasses_1.getInfoListItemUtilityClass, classes);
};
var InfoListItemRender = function (props, ref) {
    var defaultClasses = useUtilityClasses(props);
    var avatar = props.avatar, chevron = props.chevron, classes = props.classes, userClassName = props.className, divider = props.divider, hidePadding = props.hidePadding, icon = props.icon, leftComponent = props.leftComponent, rightComponent = props.rightComponent, ripple = props.ripple, subtitle = props.subtitle, subtitleSeparator = props.subtitleSeparator, info = props.info, title = props.title, wrapInfo = props.wrapInfo, wrapSubtitle = props.wrapSubtitle, wrapTitle = props.wrapTitle, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    backgroundColor = props.backgroundColor, chevronColor = props.chevronColor, fontColor = props.fontColor, iconAlign = props.iconAlign, iconColor = props.iconColor, statusColor = props.statusColor, _a = props.ListItemButtonProps, ListItemButtonProps = _a === void 0 ? {} : _a, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    otherListItemProps = __rest(props, ["avatar", "chevron", "classes", "className", "divider", "hidePadding", "icon", "leftComponent", "rightComponent", "ripple", "subtitle", "subtitleSeparator", "info", "title", "wrapInfo", "wrapSubtitle", "wrapTitle", "backgroundColor", "chevronColor", "fontColor", "iconAlign", "iconColor", "statusColor", "ListItemButtonProps"]);
    var combine = (0, react_1.useCallback)(function (className) { return (0, css_1.cx)(defaultClasses[className], classes[className]); }, [defaultClasses, classes]);
    var getIcon = (0, react_1.useCallback)(function () {
        if (icon) {
            return (react_1.default.createElement(ListItemAvatar_1.default, { style: { minWidth: 'unset' } },
                react_1.default.createElement(InfoListItemStyledComponents_1.Icon, { statusColor: statusColor, iconColor: iconColor, avatar: avatar, iconAlign: iconAlign, className: avatar ? combine('avatar') : combine('icon') }, icon)));
        }
        else if (!hidePadding) {
            return (
            // a dummy component to maintain the padding
            react_1.default.createElement(ListItemAvatar_1.default, { style: { minWidth: 'unset' } },
                react_1.default.createElement(InfoListItemStyledComponents_1.Icon, { className: combine('avatar'), statusColor: statusColor, iconColor: iconColor, avatar: avatar, isInvisible: true })));
        }
    }, [icon, avatar, hidePadding, combine]);
    var getRightComponent = (0, react_1.useCallback)(function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        rightComponent && (react_1.default.createElement(InfoListItemStyledComponents_1.RightComponent, { className: combine('rightComponent') }, rightComponent)),
        chevron && (react_1.default.createElement(InfoListItemStyledComponents_1.InfoListItemChevron, { chevronColor: chevronColor, color: 'inherit', role: 'button', className: combine('chevron') })))); }, [rightComponent, chevron, combine]);
    var getSeparator = (0, react_1.useCallback)(function () { return (react_1.default.createElement(InfoListItemStyledComponents_1.SubtitleSeparator, { className: combine('separator'), component: "span" }, subtitleSeparator || '\u00B7')); }, [combine, subtitleSeparator]);
    var getSubtitle = (0, react_1.useCallback)(function () {
        if (!subtitle) {
            return null;
        }
        if (typeof subtitle === 'string') {
            return subtitle;
        }
        var subtitleParts = Array.isArray(subtitle) ? __spreadArray([], subtitle, true) : [subtitle];
        var renderableSubtitleParts = subtitleParts.splice(0, MAX_SUBTITLE_ELEMENTS);
        return (0, utilities_1.withKeys)((0, utilities_1.separate)(renderableSubtitleParts, function () { return getSeparator(); }));
    }, [subtitle, getSeparator]);
    var getInfo = (0, react_1.useCallback)(function () {
        if (!info) {
            return null;
        }
        if (typeof info === 'string') {
            return info;
        }
        var infoParts = Array.isArray(info) ? __spreadArray([], info, true) : [info];
        var renderableInfoParts = infoParts.splice(0, MAX_SUBTITLE_ELEMENTS);
        return (0, utilities_1.withKeys)((0, utilities_1.separate)(renderableInfoParts, function () { return getSeparator(); }));
    }, [info, getSeparator]);
    var getInfoListItemContent = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InfoListItemStyledComponents_1.StatusStripe, { statusColor: statusColor, className: combine('statusStripe'), "data-testid": 'blui-status-stripe' }),
        divider && react_1.default.createElement(InfoListItemStyledComponents_1.InfoListItemDivider, { divider: divider, className: combine('divider') }),
        (icon || !hidePadding) && getIcon(),
        leftComponent,
        react_1.default.createElement(InfoListItemStyledComponents_1.InfoListItemText, { primary: title, leftComponent: leftComponent, className: combine('listItemText'), secondary: subtitle || info ? (react_1.default.createElement(react_1.default.Fragment, null,
                subtitle ? (react_1.default.createElement(InfoListItemStyledComponents_1.Subtitle, { variant: "subtitle2", component: "div", fontColor: fontColor, noWrap: !wrapSubtitle, className: combine('subtitle') }, getSubtitle())) : undefined,
                info ? (react_1.default.createElement(InfoListItemStyledComponents_1.Info, { variant: 'body2', component: "div", fontColor: fontColor, noWrap: !wrapInfo, className: combine('info') }, getInfo())) : undefined)) : undefined, primaryTypographyProps: {
                noWrap: !wrapTitle,
                variant: 'body1',
                fontWeight: 600,
                lineHeight: 1.25,
                display: 'block',
                color: fontColor || 'inherit',
                className: combine('title'),
                component: 'div',
            }, secondaryTypographyProps: {
                variant: 'subtitle2',
                color: 'textPrimary',
            } }),
        getRightComponent())); };
    return (react_1.default.createElement(InfoListItemStyledComponents_1.Root, __assign({ onClick: props.onClick, backgroundColor: backgroundColor, wrapSubtitle: wrapSubtitle, wrapTitle: wrapTitle, wrapInfo: wrapInfo, dense: props.dense, ripple: ripple, iconColor: iconColor, className: (0, css_1.cx)(combine('root'), userClassName), ref: ref }, otherListItemProps), props.onClick && ripple ? (react_1.default.createElement(InfoListItemStyledComponents_1.InfoListItemContentContainer, { className: combine('listItemButtonRoot'), focusRipple: ripple }, getInfoListItemContent())) : (getInfoListItemContent())));
};
/**
 * [InfoListItem](https://brightlayer-ui-components.github.io/react/components/info-list-item) component
 *
 * The `<InfoListItem>` is intended to be used in [`<List>`](https://material-ui.com/api/list/) views. It positions a title as well as optional subtitle(s), icon, and status stripe.
 */
exports.InfoListItem = react_1.default.forwardRef(InfoListItemRender);
exports.InfoListItem.displayName = 'InfoListItem';
exports.InfoListItem.propTypes = {
    avatar: prop_types_1.default.bool,
    backgroundColor: prop_types_1.default.string,
    chevron: prop_types_1.default.bool,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        avatar: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        rightComponent: prop_types_1.default.string,
        chevron: prop_types_1.default.string,
        separator: prop_types_1.default.string,
        subtitle: prop_types_1.default.string,
        title: prop_types_1.default.string,
    }),
    divider: prop_types_1.default.oneOf(['full', 'partial']),
    fontColor: prop_types_1.default.string,
    hidePadding: prop_types_1.default.bool,
    icon: prop_types_1.default.element,
    iconAlign: prop_types_1.default.oneOf(['left', 'right', 'center']),
    iconColor: prop_types_1.default.string,
    info: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element])),
    ]),
    leftComponent: prop_types_1.default.node,
    rightComponent: prop_types_1.default.node,
    statusColor: prop_types_1.default.string,
    style: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])),
    subtitle: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element])),
    ]),
    subtitleSeparator: prop_types_1.default.string,
    title: prop_types_1.default.node.isRequired,
    wrapInfo: prop_types_1.default.bool,
    wrapSubtitle: prop_types_1.default.bool,
    wrapTitle: prop_types_1.default.bool,
};
exports.InfoListItem.defaultProps = {
    avatar: false,
    chevron: false,
    classes: {},
    dense: false,
    hidePadding: false,
    iconAlign: 'left',
    ripple: false,
    subtitleSeparator: '\u00B7',
    wrapInfo: false,
    wrapSubtitle: false,
    wrapTitle: false,
    // @ts-ignore
    ListItemButtonProps: prop_types_1.default.object,
};
